export default __webpack_public_path__ + "static/media/infoLogo2.86816db4.webp";